var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Vue } from 'vue-property-decorator';
import AddStatusSetDialog from '@/views/School/StatusSets/AddStatusSetDialog/AddStatusSetDialog.vue';
import { LabelGroup, LabelGroupIncludes } from '@/models/LabelGroup';
import { LabelKey } from '@/models/Label';
import LabelValue from '@/components/LabelValue.vue';
import ErrorHandler from '@/support/ErrorHandler';
import { RolesEnum } from '@/items/Roles';
let StatusSets = class StatusSets extends Vue {
    constructor() {
        // #region @VModel
        // #endregion
        super(...arguments);
        // #region @PropSyncs
        // #endregion
        // #region @Props
        // #endregion
        // #region @Refs
        // #endregion
        // #region Class properties
        this.isLoading = true;
        this.sets = [];
        this.isCreatingOrEditingStatusSet = false;
        this.selectedSet = null;
        this.isEditingLabel = {};
        // protected selectedLabel: Label | null = null;
        this.selectedLabels = {};
        this.hasFilteredLabels = false;
        // #endregion
        // #region @Watchers
        // #endregion
    }
    // #endregion
    // #region Lifecycle Hooks
    mounted() {
        this.initialize();
    }
    async initialize() {
        this.isLoading = true;
        await this.fetchStatusSets();
        this.isLoading = false;
    }
    // #endregion
    // #region Event handlers
    onEditStatusSetLabel(set, label) {
        this.selectedLabels[`${set.id}-${label.key}`] = { ...label };
        this.$set(this.isEditingLabel, `${set.id}-${label.key}`, true);
    }
    onCancelEditStatusSetLabel(set, label) {
        this.selectedLabels[`${set.id}-${label.key}`] = null;
        this.$set(this.isEditingLabel, `${set.id}-${label.key}`, false);
    }
    onSaveStatusSetLabel(set, label) {
        if (!set || !label || !Object.keys(this.selectedLabels)) {
            return;
        }
        const selectedLabel = this.selectedLabels[`${set.id}-${label.key}`];
        if (!selectedLabel) {
            return;
        }
        this.updateStatusSetLabel(set, selectedLabel);
    }
    onCreateStatusSet() {
        this.isCreatingOrEditingStatusSet = true;
    }
    onEditStatusSet(set) {
        this.selectedSet = set;
        this.isCreatingOrEditingStatusSet = true;
    }
    onDeleteStatusSet(set) {
        this.selectedSet = set;
        this.$store.dispatch('openDialog', this.dialogOptions);
    }
    onCreatedStatusSet() {
        this.isCreatingOrEditingStatusSet = false;
        this.initialize();
    }
    onUpdatedStatusSet() {
        this.isCreatingOrEditingStatusSet = false;
        this.initialize();
    }
    // #endregion
    // #region Class methods
    getSetName(set) {
        if (!set || !set.name) {
            return '-';
        }
        if (set.name === 'Default') {
            return this.$tc('Default');
        }
        else {
            return set.name;
        }
    }
    getFormattedDate(date) {
        if (!date) {
            return '-';
        }
        const dateObj = new Date(date);
        const day = String(dateObj.getDate()).padStart(2, '0');
        const month = String(dateObj.getMonth() + 1).padStart(2, '0');
        const year = dateObj.getFullYear();
        return `${day}-${month}-${year}`;
    }
    getDotColor(key) {
        switch (key) {
            case LabelKey.HIGHLIGHTED:
                return '#ffc100';
            case LabelKey.BUSY:
                return '#008ac4';
            case LabelKey.CLOSED:
                return '#d0021b';
            case LabelKey.OLD:
                return '#ff7800';
            case LabelKey.INACTIVE:
                return '#9b9b9b';
            case LabelKey.FINISHED:
                return '#00b900';
            case LabelKey.FUTURE:
                return '#000000';
            case LabelKey.LESSON_DONE:
                return '#800080';
            default:
                return '#9b9b9b';
        }
    }
    // #endregion
    // #region Async methods (api calls only)
    async updateStatusSetLabel(set, label) {
        if (!set || !set.labels || !label) {
            return;
        }
        const labelsPayload = {};
        set.labels.forEach((existingLabel) => {
            this.$set(labelsPayload, existingLabel.key, existingLabel.value);
            if (existingLabel.key === label.key) {
                this.$set(labelsPayload, existingLabel.key, label.value);
            }
        });
        const payload = {
            name: set.name,
            labels: labelsPayload,
        };
        try {
            await set.update(payload);
            await this.initialize();
            this.isEditingLabel = {};
            this.selectedLabels = {};
        }
        catch (error) {
            ErrorHandler.network(error);
        }
        finally {
            //
        }
    }
    async deleteStatusSet(set) {
        try {
            await set.delete();
            this.initialize();
        }
        catch (error) {
            ErrorHandler.network(error);
        }
        finally {
            //
        }
    }
    async fetchStatusSets() {
        try {
            this.sets = await new LabelGroup().include([LabelGroupIncludes.LABELS]).all();
            // Filter labels for each set
            this.sets.forEach((set) => {
                if (set.labels) {
                    set.labels = set.labels.filter((label) => {
                        return (label.key !== LabelKey.NONE &&
                            label.key !== LabelKey.DISMISSED &&
                            label.key !== LabelKey.BUSY_HIGHLIGHTED_OLD);
                    });
                }
            });
        }
        catch (error) {
            ErrorHandler.network(error);
        }
        finally {
            //
        }
    }
    // #endregion
    // #region Getters & Setters
    get user() {
        return this.$store.state.Auth;
    }
    get isTeacherWithExpertRights() {
        if (this.user &&
            this.user.roles &&
            this.user.roles.some((role) => role.id === RolesEnum.TEACHER)) {
            // if ((this.user as Teacher).has_expert_rights) {
            // return true;
            // }
            return true;
        }
        return false;
    }
    canSeeAction() {
        const userRoles = this.user.roles;
        if (!userRoles || userRoles.length === 0) {
            return false;
        }
        if (this.isTeacherWithExpertRights) {
            return true;
        }
        const allowedRoles = [RolesEnum.ROOT, RolesEnum.ADMIN, RolesEnum.TRAINER, RolesEnum.MANAGER];
        return userRoles.some((role) => allowedRoles.includes(role.id));
    }
    get dialogOptions() {
        const set = this.selectedSet;
        return {
            title: this.$tc('dialogOptions.confirmation').toString(),
            text: this.$tc('Are you sure that you want to delete {item}?', 0, {
                item: set.name,
            }).toString(),
            type: 'warning',
            buttons: {
                confirm: {
                    text: this.$tc('dialogOptions.button.delete').toString(),
                    action: () => {
                        if (!set) {
                            return;
                        }
                        this.deleteStatusSet(set);
                    },
                },
                cancel: {
                    text: this.$t('dialogOptions.button.cancel').toString(),
                    action: () => {
                        this.selectedSet = null;
                    },
                },
            },
        };
    }
};
StatusSets = __decorate([
    Component({
        components: {
            AddStatusSetDialog,
            LabelValue,
        },
    })
], StatusSets);
export default StatusSets;
// #region Enums
// #endregion
// #region Interfaces
// #endregion
// #region Constants
// #endregion
